import React, { useContext } from 'react';
import { CheckCircle2, Circle, Info } from 'lucide-react';
import { MbContext, muted, primary } from './mbApi';
import { usePicName } from './HandoffControl';

const Step = ({ n, done, info, title, who, testid }) => (
  <li className="flex items-start gap-2" data-testid={testid}>
    {info ? <Info size={18} className="text-sky-400 shrink-0 mt-0.5" /> : done ? <CheckCircle2 size={18} className="text-emerald-400 shrink-0 mt-0.5" /> : <Circle size={18} className={`${muted} shrink-0 mt-0.5`} />}
    <span className="text-sm">
      <span className={primary}>{n}. {title}</span>
      {who && <span className={`block text-xs ${muted}`}>{who}</span>}
    </span>
  </li>
);

export const TestChecklist = ({ w, d }) => {
  const picName = usePicName();
  const { owners = {} } = useContext(MbContext);
  const tests = d.eligible.flatMap((c) => d.testsOf(c.id)).filter((t) => !t.archived);
  const all = (fn) => tests.length > 0 && tests.every(fn);
  const res = tests.map((t) => d.results[t.id]?.status3 || {});
  const azrai = picName(owners.media_buyer_id);
  const steps = [
    ['Versi lulus review', d.eligible.length > 0, `Firzan (${picName(owners.creative_id)}) — review Lulus di tab Bahan`],
    ['Cipta ujian (Ujian Baru)', tests.length > 0, `${azrai} — tekan Ujian Baru pada versi lulus`],
    ['Invite link Telegram ready', all((t) => t.invite_status === 'berjaya'), `${azrai} — "Maklumat teknikal: invite Telegram" → Generate`],
    ['Sedia URL Iklan (LP + token)', all((t) => !!t.tracking_token), `${azrai} — tekan Sedia URL Iklan, kemudian salin`],
    ['Buat iklan di Meta guna URL Iklan', null, 'Dibuat di Meta Ads Manager — CRM tak boleh sahkan langkah ni'],
    ['Padan Ad ID', all((t) => !!t.ad_id), `${azrai} — Cari Ad ID (semak & sahkan) atau taip Ad ID sendiri`],
    ['Pantau hasil', res.some((s) => s.delivering), 'Running di CRM, Aktif di Meta dan Menerima Delivery dipapar berasingan pada setiap ujian'],
  ];
  return (
    <div className="rounded-lg border border-[hsl(var(--border))] p-3" data-testid={`mb-test-checklist-${w.id}`}>
      <p className={`text-sm font-semibold ${primary} mb-2`}>Langkah persediaan ujian</p>
      <ol className="space-y-2">
        {steps.map(([title, done, who], i) => (
          <Step key={title} n={i + 1} title={title} done={!!done} info={done === null} who={done ? '' : who} testid={`mb-check-step-${i + 1}`} />
        ))}
      </ol>
    </div>
  );
};
